import React from 'react';

// Renders "₹newPrice" using the caller's own price class (so it matches
// whatever card it's dropped into). If oldPrice is set, it's shown struck
// through just before it — otherwise this renders exactly like a plain price.
const PriceTag = ({ oldPrice, newPrice, className, oldSize = 14 }) => (
  <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
    {oldPrice != null && (
      <span style={{ fontSize: oldSize, fontWeight: 600, color: 'var(--muted)', textDecoration: 'line-through' }}>
        ₹{oldPrice}
      </span>
    )}
    <span className={className}>₹{newPrice}</span>
  </span>
);

export default PriceTag;
